// TELEMEDICINE Store
import axios from "axios"

const state = {
  //baseURL: process.env.VUE_APP_URL,
  baseURL: process.env.VUE_APP_URL,
  baseWebURL: process.env.VUE_APP_HOST,
  loginRoute: "/telemedicine-login",
  createRoute: "/telemedicine-create",
  getRoute: "/telemedicine-get-room",
  appointments: "/appointments",
  appointmentsByReader: "/appointments-by-reader",
  appointmentDelete: "/delete-appointments",
  emailAppointmentApproval: "/appointment-approval-email",
  emailAppointmentReject: "/appointment-rejection-email"
}

const getters = {}

// Called from Action to change State
const mutations = {}

// Called externally to commit a State Mutation
const actions = {
  videoChatLogin({ commit }, username, room) {
    return new Promise((resolve, reject) => {
      let url = state.baseURL + state.loginRoute
      window.axios.post(url, { username: username, room: room }).then((res, err) => {
        if (err) {
          reject(err)
        }
        resolve(res.data.token)
      })
    })
  },
  videoRoomCreate({ commit }, readerID) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.createRoute
      window.axios.post(url, { readerID: readerID }).then((res, err) => {
        if (err) {
          reject(err)
        }
        resolve(res.data)
      })
    })
  },
  videoRoomGet({ commit }, readerID) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.getRoute + "/" + readerID
      window.axios.get(url).then(res => {
        if (res.data === "error") {
          reject(res)
        }
        resolve(res)
      })
    })
  },
  appointmentCreate({ commit }, appointment) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.appointments
      const config = { headers: { "Content-Type": "application/json" } }
      window.axios
        .post(url, appointment, config)
        .then((res, err) => {
          if (err) {
            console.log(err)
            reject(err)
          }
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appointmentsGetByReader({ commit }, readerID) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.appointmentsByReader + "/" + readerID
      window.axios.get(url).then((res, err) => {
        if (err) {
          console.log(err)
          reject(err)
        }
        resolve(res)
      })
    })
  },
  updateAppointment({ commit }, item) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.appointments
      const config = { headers: { "Content-Type": "application/json" } }
      const data = {
        id: item.id,
        time: item.time,
        approved: item.approved
      }
      window.axios.put(url, data, config).then((res, err) => {
        if (err) {
          console.log(err)
          reject(err)
        }
        resolve(res)
      })
    })
  },
  deleteAppointment({ commit }, id) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.appointmentDelete + "/" + id
      window.axios.delete(url).then((res, err) => {
        if (err) {
          console.log(err)
          reject(err)
        }
        resolve(res)
      })
    })
  },
  appointmentApprovalEmail({ commit }, item) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.emailAppointmentApproval
      const config = { headers: { "Content-Type": "application/json" } }
      const data = {
        patientName: item.patientName,
        readerName: item.readerName,
        readerID: item.readerID,
        time: item.time,
        recipient_address: item.email,
        url: state.baseWebURL + "/telemedicine/" + item.readerID
      }
      window.axios.post(url, data, config).then((res, err) => {
        if (err) {
          console.log(err)
          reject(err)
        }
        resolve(res)
      })
    })
  },
  appointmentRejectionEmail({ commit }, item) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.emailAppointmentReject
      const config = { headers: { "Content-Type": "application/json" } }
      const data = {
        patientName: item.patientName,
        readerName: item.readerName,
        readerID: item.readerID,
        time: item.time,
        recipient_address: item.email,
        reason: item.reason
      }
      window.axios.post(url, data, config).then((res, err) => {
        if (err) {
          console.log(err)
          reject(err)
        }
        resolve(res)
      })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
